export const calculateSolarPanelsQuery = `
  mutation CalculateSolarPanels($input: CalculateSolarPanelsInput!) {
    calculateSolarPanels(input: $input) {
      solarPanelCalculationResult {
        commonTechnical {
          accessCode
          transactionReference
        }
        policyPolicyDetails {
          orderFormId
          productCode
          productDescription
          customProperties {
            supplierKrn
          }
          companyNameDescription
          documents {
            attachmentType
            urlAttachment
          }
          conditionConditionDetails {
            documents {
              urlAttachment
            }
          }
          externalSourceName
          monthlyExtraPricing {
            price
            promotionMonths
            promotionPrice
            subtotalExclusiveVat
            subtotalInclusiveVat
            subtotalPromotionExclusiveVat
            subtotalPromotionInclusiveVat
          }
          onetimeExtraPricing {
            subtotalPromotionInclusiveVat
            subtotalPromotionExclusiveVat
            subtotalInclusiveVat
            subtotalExclusiveVat
            promotionPrice
            promotionMonths
            price
          }
          pricingTotals {
            monthlyExcludingVat
            monthlyIncludingVat
            netInvestment
            onetimeExcludingVat
            onetimeIncludingVat
          }
          productDescription
          refKey
          savingBenefits {
            returnOnInvestmentAfter1year
            returnOnInvestmentAfter10years
            returnOnInvestmentAfter25years
            returnOnInvestmentInYears
            returnOnInvestmentLabel
          }
          supplierExternalId
          uniqueSellingPoint
          yearlyGenerationInKwh
          coverageHomes {
            uniqueSellingPoint
            refKey
            refTypeDescription
            productDescription
            externalSourceName
            documents {
              urlAttachment
              attachmentType
            }
            solarPanels {
              color
              height
              quantity
              wattPeak
              width
              yearlyLoss
              powerOutput
              maxPower
            }
          }
        }
      }
    }
  }
`;

export default calculateSolarPanelsQuery;
